import React from "react";
import { useSelector } from "react-redux";

const AuthNine = () => {
  const locale = useSelector((state) => state.theme.locale);

  return (
    <div
      className="flex-1 flex flex-col items-center justify-center bg-no-repeat bg-cover text-center p-5"
      style={{ backgroundImage: `url('/img/auth/9.jpg')` }}
    >
      <img className="mb-10" alt="Carbon" src="/img/auth/icon6.png" />
      {locale === "en" ? (
        <p className="font-semibold text-[40px] text-white leading-snug max-w-[624px]">
          Experience Mol-e with a 14-day demo and see the difference in your
          e-waste management approach.
        </p>
      ) : (
        <p className="font-semibold text-[40px] text-white leading-snug max-w-[624px]">
          14 günlük demo ile Mol-e'yi deneyimleyin ve e-atık yönetim
          yaklaşımınızda farkı görün.
        </p>
      )}
    </div>
  );
};

export default AuthNine;
